import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import resolveCoverLaySideName from "../../../../../service/sideNameResolver/resolveCoverLaySideName"
import type { OneClickFieldProps } from "../../../../../types"
import ColorPattern from "../../../../components/1Click/form/ColorPattern/ColorPattern"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"

const 貼る面 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { coverLaySide: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="貼る面">
      <RadioGroup name={FIELD_NAMES.貼る面} selectedValue={values.coverLaySide} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio
            value={ESTIMATE_CONSTANT.貼る面.両面貼る.value}
            prefixNode={<ColorPattern pattern="both" values={values} />}
          >
            両面貼る
          </Radio>
          <Radio
            value={ESTIMATE_CONSTANT.貼る面["パターン面と同じ面を貼る(L1面を貼る)"].value}
            prefixNode={<ColorPattern pattern="top" values={values} />}
          >
            {resolveCoverLaySideName(ESTIMATE_CONSTANT.貼る面["パターン面と同じ面を貼る(L1面を貼る)"].value, values)}
          </Radio>
          <Radio
            value={ESTIMATE_CONSTANT.貼る面["パターン面とは逆の面を貼る(Ln面を貼る)"].value}
            prefixNode={<ColorPattern pattern="bottom" values={values} />}
          >
            {resolveCoverLaySideName(ESTIMATE_CONSTANT.貼る面["パターン面とは逆の面を貼る(Ln面を貼る)"].value, values)}
          </Radio>
          <Radio
            value={ESTIMATE_CONSTANT.貼る面.貼らない.value}
            prefixNode={<ColorPattern pattern="none" values={values} />}
          >
            貼らない
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.coverLaySide} />
    </OneClickField>
  )
}

export default 貼る面
